export default __webpack_public_path__ + "static/race-day-half-marathon-square-17201f4ba0dddbff2fb9ecfdcf4344e2.png";